import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { Careseeker } from "core/types";

export function useFileTransferAllowed(careseeker?: Careseeker) {
  const { app } = useEnvContext();

  const isCareProvider = app === APP_CAREPROVIDER;
  // Transfers enabled by default unless explicitly disabled with deactivate_received_files
  const isFileTransferEnabled = !careseeker?.config?.deactivate_received_files;

  return {
    canReceiveFiles: isCareProvider || isFileTransferEnabled,
    canSendFiles: !isCareProvider || isFileTransferEnabled,
  };
}
